module.exports = __webpack_public_path__ + "img/7691cd4.jpg";